import { AccountInfo } from '@azure/msal-browser';

import { configuration } from 'util/configurations';

/**
 * Determines whether an authenticated Entra ID account may access the portal.
 *
 * Authorization is driven by the `roles` (Entra app roles) and `groups` (security
 * group object ids) claims on the account's ID token, matched against the
 * configured {@link configuration.requiredRoles}. When no required roles are
 * configured (Entra app roles/groups not yet provisioned), any authenticated user
 * is allowed — mirroring the BFF, which currently performs no RBAC.
 */
export function hasRequiredAccess(account?: AccountInfo | null): boolean {
  const required = configuration.requiredRoles ?? [];
  if (required.length === 0) return true;
  if (!account) return false;

  const claims = (account.idTokenClaims ?? {}) as Record<string, unknown>;
  const roles = Array.isArray(claims.roles) ? (claims.roles as string[]) : [];
  const groups = Array.isArray(claims.groups)
    ? (claims.groups as string[])
    : [];
  const held = [...roles, ...groups];

  return required.some((r) => held.includes(r));
}
